export const FETCH_RAMPS = `FETCH_RAMPS`;
export const FETCH_RAMPS_SUCCESS = `FETCH_RAMPS_SUCCESS`;
export const FETCH_RAMPS_FAILED = `FETCH_RAMPS_FAILED`;

export const fetchRamps = () => ({
  type: FETCH_RAMPS,
});

export const fetchRampsSuccess = (payload: any) => ({
  type: FETCH_RAMPS_SUCCESS,
  payload,
});

export const fetchRampsFailed = (payload: any) => ({
  type: FETCH_RAMPS_FAILED,
  payload,
});

export const FETCH_ASSIGNMENTS = `FETCH_ASSIGNMENTS`;
export const FETCH_ASSIGNMENTS_SUCCESS = `FETCH_ASSIGNMENTS_SUCCESS`;
export const FETCH_ASSIGNMENTS_FAILED = `FETCH_ASSIGNMENTS_FAILED`;

export const fetchAssignments = (payload: any) => ({
  type: FETCH_ASSIGNMENTS,
  payload,
});

export const fetchAssignmentsSuccess = (payload: any) => ({
  type: FETCH_ASSIGNMENTS_SUCCESS,
  payload,
});

export const fetchAssignmentsFailed = (payload: any) => ({
  type: FETCH_ASSIGNMENTS_FAILED,
  payload,
});

export const SAVE_RAMP = `SAVE_RAMP`;
export const SAVE_RAMP_SUCCESS = `SAVE_RAMP_SUCCESS`;
export const SAVE_RAMP_FAILED = `SAVE_RAMP_FAILED`;

export const saveRamp = (payload: any) => ({
  type: SAVE_RAMP,
  payload,
});

export const saveRampSuccess = (payload: any) => ({
  type: SAVE_RAMP_SUCCESS,
  payload,
});

export const saveRampFailed = (payload: any) => ({
  type: SAVE_RAMP_FAILED,
  payload,
});

export const SAVE_ASSIGNMENT = `SAVE_ASSIGNMENT`;
export const SAVE_ASSIGNMENT_SUCCESS = `SAVE_ASSIGNMENT_SUCCESS`;
export const SAVE_ASSIGNMENT_FAILED = `SAVE_ASSIGNMENT_FAILED`;

export const saveAssignment = (payload: any) => ({
  type: SAVE_ASSIGNMENT,
  payload,
});

export const saveAssignmentSuccess = (payload: any) => ({
  type: SAVE_ASSIGNMENT_SUCCESS,
  payload,
});

export const saveAssignmentFailed = (payload: any) => ({
  type: SAVE_ASSIGNMENT_FAILED,
  payload,
});

export const APPLY_ASSIGNMENT = `APPLY_ASSIGNMENT`;
export const APPLY_ASSIGNMENT_SUCCESS = `APPLY_ASSIGNMENT_SUCCESS`;
export const APPLY_ASSIGNMENT_FAILED = `APPLY_ASSIGNMENT_FAILED`;

export const applyAssignment = (payload: any) => ({
  type: APPLY_ASSIGNMENT,
  payload,
});

export const applyAssignmentSuccess = (payload: any) => ({
  type: APPLY_ASSIGNMENT_SUCCESS,
  payload,
});

export const applyAssignmentFailed = (payload: any) => ({
  type: APPLY_ASSIGNMENT_FAILED,
  payload,
});

export const DELETE_ASSIGNMENT = `DELETE_ASSIGNMENT`;
export const DELETE_ASSIGNMENT_SUCCESS = `DELETE_ASSIGNMENT_SUCCESS`;
export const DELETE_ASSIGNMENT_FAILED = `DELETE_ASSIGNMENT_FAILED`;

export const deleteAssignment = (payload: any) => ({
  type: DELETE_ASSIGNMENT,
  payload,
});

export const deleteAssignmentSuccess = (payload: any) => ({
  type: DELETE_ASSIGNMENT_SUCCESS,
  payload,
});

export const deleteAssignmentFailed = (payload: any) => ({
  type: DELETE_ASSIGNMENT_FAILED,
  payload,
});

export const OPEN_ASSIGNMENT_MODAL = `OPEN_ASSIGNMENT_MODAL`;
export const CLEAR_ASSIGNMENT_MODAL = `CLEAR_ASSIGNMENT_MODAL`;

export const openAssignmentModal = (payload: any) => ({
  type: OPEN_ASSIGNMENT_MODAL,
  payload,
});

export const clearAssignmentModal = () => ({
  type: CLEAR_ASSIGNMENT_MODAL,
});
